import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/GridModal.css";
import Zoomproduct from "../../../../Component/Zoomproduct";
import CartAdd from "./CartAdd";

const ModalBoxPopupwish = ({
  Modal,
  detailModalShow,
  handleDetailModalClose,
  Button,
  currentImage,
  product,
}) => {
  const [quantity, setQuantity] = useState("");
  const [isCustomInput, setIsCustomInput] = useState(false);
  const [zoomModalShow, setZoomModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // 1-9 automatic add
  const [autoAddQuantity, setAutoAddQuantity] = useState(null);

  // 10+ ke liye pending/update quantity
  const [pendingQuantity, setPendingQuantity] = useState(null);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (detailModalShow) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "0px";

      const header = document.querySelector("header");

      if (header) {
        header.style.paddingRight = "0px";
      }
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "0px";

      const header = document.querySelector("header");

      if (header) {
        header.style.paddingRight = "0px";
      }
    }

    return () => {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "0px";
    };
  }, [detailModalShow]);

  // ------------------------------------------
  // Quantity Select
  // ------------------------------------------
  const handleSelectChange = (e) => {
    const value = e.target.value;

    // -----------------------------
    // 10+ CUSTOM INPUT
    // -----------------------------
    if (value === "10+") {
      setIsCustomInput(true);

      // 10 se start
      setQuantity("10");

      // Update button ke liye pending quantity
      setPendingQuantity(10);

      // Automatic add nahi hoga
      setAutoAddQuantity(null);

      return;
    }

    const selectedQuantity = Number(value);

    setQuantity(value);
    setIsCustomInput(false);

    // 1-9 = automatic add
    if (
      selectedQuantity >= 1 &&
      selectedQuantity <= 9
    ) {
      setPendingQuantity(null);
      setAutoAddQuantity(selectedQuantity);
    } else {
      setAutoAddQuantity(null);
      setPendingQuantity(null);
    }
  };

  // ------------------------------------------
  // 10+ Custom Input
  // ------------------------------------------
  const handleCustomInputChange = (e) => {
    const value = e.target.value;

    // Sirf number
    if (!/^\d*$/.test(value)) {
      return;
    }

    setQuantity(value);

    // Custom input mein automatic add nahi
    setAutoAddQuantity(null);

    // Empty hone par Update disabled
    if (value === "") {
      setPendingQuantity(null);
      return;
    }

    const qty = Number(value);

    // 10+ hi hona chahiye
    if (qty >= 10) {
      setPendingQuantity(qty);
    } else {
      setPendingQuantity(null);
    }
  };

  // ------------------------------------------
  // Zoom
  // ------------------------------------------
  const handleZoomClick = () => {
    setZoomModalShow(true);
  };

  const handleZoomClose = () => {
    setZoomModalShow(false);
  };

  // ------------------------------------------
  // Auto Add Complete
  // ------------------------------------------
  const handleAutoAddComplete = () => {
    setAutoAddQuantity(null);
  };

  return (
    <>
      <Modal
        show={detailModalShow}
        onHide={handleDetailModalClose}
        fullscreen
        centered
        restoreFocus={false}
        enforceFocus={false}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="text-center">
          <Button
            variant="light"
            onClick={handleDetailModalClose}
            className="position-absolute top-0 end-0 close-btns"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>

          <div className="box-Content-Ration">
            <div className="row">

              {/* IMAGE */}
              <div className="col-md-4">
                <div className="image-gallery position-relative">

                  {isLoading ? (
                    <Skeleton
                      height={400}
                      width="100%"
                    />
                  ) : currentImage ? (
                    <img
                      src={currentImage}
                      alt="Detailed View"
                      style={{
                        width: "100%",
                        height: "auto",
                        border: "1px dotted #ff935c",
                      }}
                    />
                  ) : (
                    <p>
                      No detailed data available.
                    </p>
                  )}

                  <span
                    className="zoomicon"
                    onClick={handleZoomClick}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "0px",
                      right: "10px",
                    }}
                  >
                    <i className="bi bi-zoom-in"></i>
                  </span>
                </div>

                <h3
                  className="text-xl text-gray-500"
                  style={{ fontSize: "16px" }}
                >
                  {isLoading ? (
                    <Skeleton width={150} />
                  ) : (
                    <>
                      {product?.quality_name || "N/A"}{" "}

                      <span
                        style={{
                          color: "rgb(225, 50, 54)",
                          fontWeight: 400,
                        }}
                      >
                        {product?.design_shade
                          ? product.design_shade
                              .split(" ")
                              .map(
                                (
                                  word,
                                  index,
                                  words
                                ) => (
                                  <React.Fragment
                                    key={index}
                                  >
                                    {index === 0
                                      ? word
                                          .split(
                                            /(\d+)/
                                          )
                                          .map(
                                            (
                                              part,
                                              i
                                            ) =>
                                              /^\d+$/.test(
                                                part
                                              ) ? (
                                                <span
                                                  key={i}
                                                >
                                                  {
                                                    part
                                                  }
                                                </span>
                                              ) : (
                                                <strong
                                                  key={i}
                                                >
                                                  {
                                                    part
                                                  }
                                                </strong>
                                              )
                                          )
                                      : word}

                                    {index <
                                      words.length -
                                        1 &&
                                      " "}
                                  </React.Fragment>
                                )
                              )
                          : ""}
                      </span>
                    </>
                  )}
                </h3>
              </div>

              {/* DETAILS */}
              <div className="col-md-8">
                <div className="text-left">

                  <h4 className="text-gray-500 pt-2 font-normal">
                    {isLoading ? (
                      <Skeleton width={100} />
                    ) : (
                      "SPECIFICATION"
                    )}
                  </h4>

                  <p className="text-gray-600">
                    {isLoading ? (
                      <Skeleton count={3} />
                    ) : (
                      product?.specification ||
                      product?.description ||
                      product?.product_description ||
                      product?.specifications ||
                      "No Specification Available"
                    )}
                  </p>

                  {/* CART */}
                  <CartAdd
                    product={product}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    isCustomInput={isCustomInput}
                    onQuantityChange={
                      handleSelectChange
                    }
                    onCustomInputChange={
                      handleCustomInputChange
                    }
                    autoAddQuantity={
                      autoAddQuantity
                    }
                    onAutoAddComplete={
                      handleAutoAddComplete
                    }
                    pendingQuantity={
                      pendingQuantity
                    }
                  />

                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* ZOOM */}
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
};

export default ModalBoxPopupwish;